import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "e8a41a80-6e51-4204-aa1c-6930d09676ac",
    content: `<math xmlns=http://www.w3.org/1998/Math/MathML display=block class=equation>
      <mstyle mathvariant=none>
      <mi>T</mi>
      <mo>=</mo>
      <mo>-</mo>
      <mo>(</mo>
      <mn>0.163</mn>
      <mfrac>
      <mrow>
          <mi>s</mi>
      </mrow>
      <mrow>
          <mi>m</mi>
      </mrow>
      </mfrac>
      <mo>)</mo>
      <mfrac>
      <mrow>
          <mi>V</mi>
      </mrow>
      <mrow>
          <mi>S</mi>
          <mspace width="5px" />
          <mi>ln</mi>
          <mo>(</mo>
          <mn>1</mn>
          <mo>-</mo>
          <mi>a</mi>
          <mo>)</mo>
      </mrow>
      </mfrac>
      </mstyle>
    </math>`,
    options: {},
  },
  {
    id: "c2aa7c02-5378-4cb5-971c-6eb21d9620c8",
    content: `<math xmlns=http://www.w3.org/1998/Math/MathML display=block class=equation>
      <mstyle mathvariant=none fontsize="16px">
      <mi>T</mi>
      <mo>=</mo>
      <mo>(</mo>
      <mn>0.163</mn>
      <mfrac>
      <mrow>
          <mi>s</mi>
      </mrow>
      <mrow>
          <mi>m</mi>
      </mrow>
      </mfrac>
      <mo>)</mo>
      <mfrac>
      <mrow>
          <mi>V</mi>
      </mrow>
      <mrow>
          <mi>S</mi>
          <mi>a</mi>
      </mrow>
      </mfrac>
      </mstyle>
    </math>`,
    options: {},
  },
];

const groups = [
  {
    id: "6bea9445-566d-4f6c-82a5-1aa08bbe5eb9",
    content: "sabine",
    options: {},
  },
  {
    id: "058e459a-a145-480b-a985-3ae6397a3212",
    content: "eyring",
    options: {},
  },
];

export const task: Task = {
  id: "6838f313-3382-43ad-8de9-4c1aae896a95",
  solutionType: "group",
  type: "categorizeLabels",
  options: {
    orientation: "vertical",
    shuffle: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    {
      groupId: "6bea9445-566d-4f6c-82a5-1aa08bbe5eb9",
      itemsId: ["c2aa7c02-5378-4cb5-971c-6eb21d9620c8"],
    },
    {
      groupId: "058e459a-a145-480b-a985-3ae6397a3212",
      itemsId: ["e8a41a80-6e51-4204-aa1c-6930d09676ac"],
    },
  ],
};
